"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var theme_1 = require("./theme");

var GlobalStyle = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    color: #020202;\n    font-family: sans-serif;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n"], ["\n  body {\n    color: #020202;\n    font-family: sans-serif;\n  }\n\n  * {\n    box-sizing: border-box;\n  }\n"])));

exports.Provider = function (props) {
  var theme = theme_1.getTheme({
    theme: props.theme,
    isDarkMode: props.isDarkMode
  });
  return React.createElement(styled_components_1.ThemeProvider, {
    theme: theme
  }, React.createElement(React.Fragment, null, props.children, React.createElement(GlobalStyle, null)));
};

var templateObject_1;